import script from "./Ver.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ver.vue?vue&type=script&lang=ts&setup=true"

import "./Ver.vue?vue&type=style&index=0&id=e3d07cd6&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3d07cd6"]])

export default __exports__